import {
  AppWindow, BookOpen, ChartLine, CreditCard, FileText, Library, MessagesSquare,
  Rocket, Scale, ShieldCheck, Sparkles, Zap, type LucideIcon,
} from 'lucide-react';

export type NavSubItem = { href: string; label: string };
// Icons on top-level entries only; sub-items stay text so the sidebar doesn't get busy.
export type NavItem = { href: string; label: string; icon: LucideIcon; items?: NavSubItem[] };
export type NavSection = { key: string; label: string; items: NavItem[] };

export const DOC_NAV: NavSection[] = [
  {
    key: 'getting_started',
    label: 'Getting Started',
    items: [
      { href: '/docs', label: 'Introduction', icon: BookOpen },
      { href: '/docs/getting-started', label: 'Create your Twin', icon: Sparkles },
    ],
  },
  {
    key: 'features',
    label: 'Features',
    items: [
      {
        href: '/docs/knowledge-base',
        label: 'Knowledge Base',
        icon: Library,
        items: [
          { href: '/docs/knowledge-base/files', label: 'Files' },
          { href: '/docs/knowledge-base/website', label: 'Website' },
          { href: '/docs/knowledge-base/qa', label: 'Q&A' },
          { href: '/docs/knowledge-base/notion', label: 'Notion' },
        ],
      },
      {
        href: '/docs/actions',
        label: 'Actions',
        icon: Zap,
        items: [
          { href: '/docs/actions/collect-leads', label: 'Collect Leads' },
          { href: '/docs/actions/escalations', label: 'Escalations' },
          { href: '/docs/actions/tools', label: 'Tool integrations' },
        ],
      },
      { href: '/docs/widgets', label: 'Widgets', icon: AppWindow },
      { href: '/docs/activity', label: 'Activity', icon: MessagesSquare },
      { href: '/docs/analytics', label: 'Analytics', icon: ChartLine },
      { href: '/docs/deploy', label: 'Deploy', icon: Rocket },
    ],
  },
  {
    key: 'account',
    label: 'Account',
    items: [
      { href: '/docs/billing', label: 'Billing & Plans', icon: CreditCard },
    ],
  },
  {
    key: 'legal',
    label: 'Legal',
    items: [
      { href: '/docs/legal-notice', label: 'Legal Notice', icon: Scale },
      { href: '/docs/privacy-policy', label: 'Privacy Policy', icon: ShieldCheck },
      { href: '/docs/terms', label: 'Terms of Service', icon: FileText },
    ],
  },
];
